import { ExpressTier } from "data-types";
import { SELF_PICKUP } from "../constants";

// HL-13005: server-verified DHL/Express, plus self-pickup from rxSelfPickup (the pharmacy sheet's list); Express only if the page shows that tier.
export const resolveDeliveryUnavailableOptions = (params: {
  serverOptions: string[];
  isExpressFlow: boolean;
  tiersToShow: ExpressTier[];
  rxSelfPickup: { isEligible: boolean; pharmacyCards: Record<string, unknown> };
}): string[] => {
  const { serverOptions, isExpressFlow, tiersToShow, rxSelfPickup } = params;
  const options: string[] = serverOptions.filter((option) => option === "regular");
  if (rxSelfPickup.isEligible && Object.keys(rxSelfPickup.pharmacyCards).length > 0) {
    options.push(SELF_PICKUP);
  }
  const expressTier = isExpressFlow
    ? tiersToShow.find((tier) => !tier.isCutoffPassed && serverOptions.includes(tier.tier))?.tier
    : undefined;
  return expressTier ? [...options, expressTier] : options;
};
